"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _index = _interopRequireDefault(require("../profile-popup/index"));

var _globals = _interopRequireWildcard(require("@insided/shared/utils/globals"));

var _getWithInMemoryCache = _interopRequireDefault(require("../../utils/getWithInMemoryCache"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'user-mention';
exports.cssAnchorName = cssAnchorName;

var UserMentions = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UserMentions, _Component);

  var _super = _createSuper(UserMentions);

  function UserMentions(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UserMentions);
    _this = _super.call(this, props);
    _this.state = {
      doesUserExist: false
    };
    return _this;
  }

  (0, _createClass2.default)(UserMentions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      (0, _getWithInMemoryCache.default)('/member/doesUserExist', {
        memberId: this.props.id
      }).then(function (res) {
        return _this2.setState({
          doesUserExist: res.result
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var state = this.state;
      var id = props.id,
          content = props.content,
          parentEl = props.parentEl;
      return (0, _preact.h)("span", null, state.doesUserExist ? (0, _preact.h)("a", {
        className: "".concat(!state.doesUserExist ? 'anonymous-user' : ''),
        href: (0, _absoluteUrlRuntime.resolveUrl)((0, _globals.default)('application') !== 'control' ? "".concat((0, _globals.getSubfolderPrefix)(), "/members/mid-").concat(id) : "".concat((0, _globals.getSubfolderPrefix)(), "/member/profile?userid=").concat(id))
      }, content, (0, _preact.h)(_index.default, {
        hoverControl: parentEl,
        memberId: id
      })) : (0, _preact.h)("span", null, content));
    }
  }]);
  return UserMentions;
}(_preact.Component);

var _default = UserMentions;
exports.default = _default;